import React from "react";
import ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";
import App from "./App";
import api from "./services/api";
import { i18n, sentry } from "./config";
import { default as SatisfactionSurveyTicket } from "./components/SatisfactionSurvey";
import MultiRequestors from "./components/SatisfactionSurvey/MultiRequestors";
import GlobalStyle from "./styles";
import envs from "./utils/envs";
import { captureException } from "@sentry/browser";

sentry();

// eslint-disable-next-line no-undef
if (__ENV__ === envs.development.name || __ENV__ === envs.staging.name)
  ReactDOM.render(<App />, document.getElementById("root"));

const params = new URLSearchParams(window.location.search);

// eslint-disable-next-line no-undef
const instMoviContext = __ENV__ !== envs.productionMovidesk.name;

let token = "";
let language = "";

if (params.get("t")) {
  token = params.get("t");
}

if (params.get("language")) {
  language = params.get("language");
}

if (!token.length) {
  token = decodeURIComponent(window.location.search.substr(1));
}

instMoviContext &&
  (async () => {
    try {
      const { data } = await api.get(`/?token=${encodeURIComponent(token)}&language=${encodeURIComponent(language)}`);
      let isNewSurvey = false;
      data.questions.length
        ? (isNewSurvey = true)
        : window.location.assign(
            `https://pesquisas.movidesk.com/?${encodeURIComponent(token)}`
          );

      isNewSurvey && ReactDOM.render(<App />, document.getElementById("root"));
    } catch (er) {
      captureException(er);
      console.error(er);
    }
  })();

export class SatisfactionSurveyComponent {
  constructor(selector) {
    this.selector = selector;
  }

  render() {
    ReactDOM.render(<App />, document.querySelector(this.selector));
  }

  renderOnTicketPage(props = {}) {
    if (props.lang) {
      i18n.changeLanguage(props.lang);
    }
    ReactDOM.render(
      <>
        <GlobalStyle />
        <I18nextProvider i18n={i18n}>
          <SatisfactionSurveyTicket {...props} isMovideskContext={true} />
        </I18nextProvider>
      </>,
      document.querySelector(this.selector)
    );
  }

  renderOnTicketMultiRequestors(props = {}) {
    if (props.lang) {
      i18n.changeLanguage(props.lang);
    }
    ReactDOM.render(
      <>
        <GlobalStyle />
        <I18nextProvider i18n={i18n}>
          <MultiRequestors {...props} />
        </I18nextProvider>
      </>,
      document.querySelector(this.selector)
    );
  }
}
